module.exports = __webpack_public_path__ + "static/media/SVGFirstPost.084881b1.webp";